var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediodia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1554",
    "data-name": "Group 1554",
    transform: "translate(14) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M3,0A3,3,0,1,0,6,3,3.009,3.009,0,0,0,3,0ZM3,5A2,2,0,1,1,5,3,2.006,2.006,0,0,1,3,5Z",
    transform: "translate(4 4)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M.5,0A.472.472,0,0,0,0,.5v2A.472.472,0,0,0,.5,3,.472.472,0,0,0,1,2.5V.5A.472.472,0,0,0,.5,0Z",
    transform: "translate(6.5 11)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M.5,0A.472.472,0,0,0,0,.5v2A.472.472,0,0,0,.5,3,.472.472,0,0,0,1,2.5V.5A.472.472,0,0,0,.5,0Z",
    transform: "translate(6.5)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M1.9,0a.454.454,0,0,0-.35.15L.15,1.55a.483.483,0,0,0,0,.7.483.483,0,0,0,.7,0L2.25.85a.483.483,0,0,0,0-.7A.454.454,0,0,0,1.9,0Z",
    transform: "translate(1.9 9.7)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M1.9,0a.454.454,0,0,0-.35.15L.15,1.55a.483.483,0,0,0,0,.7.483.483,0,0,0,.7,0L2.25.85a.483.483,0,0,0,0-.7A.54.54,0,0,0,1.9,0Z",
    transform: "translate(9.7 1.9)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M2.5,0H.5A.472.472,0,0,0,0,.5.472.472,0,0,0,.5,1h2A.472.472,0,0,0,3,.5.472.472,0,0,0,2.5,0Z",
    transform: "translate(0 6.5)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M2.5,0H.5A.472.472,0,0,0,0,.5.472.472,0,0,0,.5,1h2A.472.472,0,0,0,3,.5.472.472,0,0,0,2.5,0Z",
    transform: "translate(11 6.5)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M.5,0A.454.454,0,0,0,.15.15a.483.483,0,0,0,0,.7l1.4,1.4a.495.495,0,0,0,.7-.7L.85.15A.454.454,0,0,0,.5,0Z",
    transform: "translate(1.9 1.9)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M.5,0A.454.454,0,0,0,.15.15a.483.483,0,0,0,0,.7l1.4,1.4a.495.495,0,0,0,.7-.7L.85.15A.54.54,0,0,0,.5,0Z",
    transform: "translate(9.7 9.7)",
    fill: "#000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediodia);
export default __webpack_public_path__ + "static/media/mediodia.bf0705bcc35de85e3ac6478c325637c1.svg";
export { ForwardRef as ReactComponent };